import React, { useMemo, useState, useEffect } from 'react';

import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import MaterialReactTable from 'material-react-table';
import typography from "assets/mavric-theme/base/typography";
import colors from "assets/mavric-theme/base/colors";
import {
    Typography, Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Select, MenuItem, Grid, Snackbar, Alert, DialogContentText, Autocomplete,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {deleteProbe } from "../../apis/CustomersApis"

const { size } = typography;
const { primary, secondary, text, white, tableRow, transparent } = colors;
const ITEM_HEIGHT = 48;

const ProbeStatus_table = (props) => {
    
    const columns = useMemo(
        () => [
            {
                header: 'Serial Number',
                accessorKey: 'probe_serial_number',
                id:'probe_serial_number',
                enableColumnFilter: true,
                Filter: ({ header }) => (
                  <Autocomplete
                      // multiple
                      size="small"
                      options={probeSerialNumOption}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option}
                      renderOption={(props, option, { selected }) => (
                          <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
                      )}
                      style={{ width: 150 }}
                      renderInput={(params) => (
                          <TextField {...params} variant="outlined" placeholder="Probe Serial Number" />
                      )}
                      sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
                      onChange={(event, value) =>
                          header.column.setFilterValue(value)}
                      clearIcon={<HighlightOffIcon fontSize="small" />}
                      ListboxProps={{
                          sx: {
                              maxHeight: ITEM_HEIGHT * 4.5,
                          }
                      }}
                  />
              ),
              filterFn: 'ProbeFilterFn',
            },
            {
                header: 'Name',
                accessorKey: 'name',
                id:'name',
                enableColumnFilter: false,
            },
            {
                header: 'Stream Id',
                accessorKey: 'probe_stream_id',
                id:'probe_stream_id',
                enableColumnFilter: false,
            },
            {
                header: 'WPN Probe Type',
                accessorKey: 'prod_wpn',
                id:'prod_wpn',
                enableColumnFilter: false,
            },
            {
                header: 'Probe Type',
                accessorKey: 'prod_wpn_display_name',
                id:'prod_wpn_display_name',
                enableColumnFilter: false,
            },
            {
                header: 'Status',
                accessorKey: 'probe_status',
                id:'probe_status',
                enableColumnFilter: false,
            },
        ],[]
      )

    const [probeData, setProbeData] = useState([]);
    const MyStateRole = useSelector(state => state.role);
    const isAccounting = (MyStateRole === "accounting") ? true : false;
    const isSalesOperator = (MyStateRole === "salesoperator") ? true : false;
    const isSalesAdmin = (MyStateRole === "salesadmin") ? true : false;
    const isSupport = (MyStateRole === "support") ? true : false;
    const [muiTableKey, setMuiTableKey] = useState(0);
    const [selectedProbes, setSelectedProbes] = useState([]);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [pageAlertType, setPageAlertType] = useState("error");
    const [alertState, setAlertState] = useState({ openAlert: false, alertSeverity: "error", alertMessage: "", vertical: 'bottom', horizontal: 'left' });
    const { openAlert, alertSeverity, alertMessage, vertical, horizontal } = alertState;
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [deleteMessageConfirm, setDeleteMessageConfirm] = useState("");
    const [deleteMessageConfirmTitle, setDeleteMessageConfirmTitle] = useState("");
    const [deleteAlertMsg, setDeleteAlertMsg] = useState("");
    const [probeSerialNumOption, setprobeSerialNumOption] = useState([]);

    useEffect(() => {
      if (props.data) {
        setProbeData(props.data);
      }
    }, [props.data]);

    useEffect(() => {
      if (Array.isArray(probeData) && probeData.length > 0) {
        prepareProbeData(probeData);
      }
    }, [probeData]);

    const prepareProbeData = (data) => {
      let updtdProbeOptions = probeSerialNumOption;
    
      data.map(row => {
          const isDuplicateProbeNum = updtdProbeOptions.includes(row.probe_serial_number);
          if (!isDuplicateProbeNum) {
            updtdProbeOptions.push(row.probe_serial_number);
          }
      });
      setprobeSerialNumOption(updtdProbeOptions);
  }
    const resetMyFilters = () => {
      setMuiTableKey(muiTableKey + 1);
    };

    const handleDeleteProbe = () => {
      let strMsg = "Are you sure you want to delete?";
      setDeleteMessageConfirm(strMsg);
      setDeleteMessageConfirmTitle("Delete selected");
      setConfirmDeleteOpen(true);
    };

    const handleDeleteYes = () => {
      setConfirmDeleteOpen(false);
      // console.log(selectedProbes);
      if (selectedProbes.length > 0) {
        deleteProbes(selectedProbes);
      }
      resetMyFilters();
      setSelectedProbes([]);
    }
  
    const handleDeleteNo = () => {
      resetMyFilters();
      setSelectedProbes([]);
      setConfirmDeleteOpen(false);
    };
  
    const handleConfirmClose = () => {
      setConfirmDeleteOpen(false);
      setSelectedProbes([]);
    };

    const deleteProbes = async (selectedProbes) => {
      let errorList = [];
      let deletedUsers = [];
    
      for (let idx = 0; idx < selectedProbes.length; idx++) {
        let probeInfo = selectedProbes[idx];
    
        try {
          const result = await deleteProbe(probeInfo.probe_serial_number);
    
          if (result.code !== 200) {
            probeInfo['error_msg'] = JSON.stringify(result);
            errorList.push(probeInfo);
          } else {
            deletedUsers.push(probeInfo);
          }
        } catch (error) {
          probeInfo['error_msg'] = error;
          errorList.push(probeInfo);
        }
      }
    
      // ❗️ Filter out all deleted probes in one step
      const updatedProbes = probeData.filter(d =>
        deletedUsers.some(deleted => deleted.probe_serial_number === d.probe_serial_number) === false
      );
    
      setProbeData(updatedProbes);
    
      // Call refresh only once
      props.getProbesByCustomerId(
        props.selectedCustomer.customer_id,
        props.selectedCustomer.org_name
      );
    
      setShowDeleteAlert(true);
      if (errorList.length > 0) {
        console.error("Error: Probe List :", errorList);
        setPageAlertType("error");
        setDeleteAlertMsg(`Error: ${errorList.length} probe(s) were not deleted`);
      } else {
        setPageAlertType("success");
        setDeleteAlertMsg(`Success : ${deletedUsers.length} probe(s) were deleted`);
      }
    };

    const handleDeleteAlertClose = (event, reason) => {

        if (reason === 'clickaway') {
        return;
        }
        setAlertState({ ...alertState, openAlert: false });
        setShowDeleteAlert(false);
    
    }

    return (
    <MaterialReactTable 
      columns={columns} 
      data={probeData}
      defaultColumn={{ size: 125 }}
      key={muiTableKey}
      muiTableToolbarAlertBannerProps={{ sx: {display: 'none'} }}
      muiTablePaperProps={{ sx: {boxShadow: 'none', backgroundColor: primary.main} }}
      muiTableBodyRowProps={({ row }) => ({
        hover: true,
        sx: {
          color: text.main,
          align: 'center',
          '&:nth-of-type(odd)': {
            backgroundColor: tableRow.dark,
            border:0,
          },
          '&:nth-of-type(even)': {
            background: tableRow.light,
          },
          // hide last border
          '&:last-child td, &:last-child th': {
            border: 0,
          },
          '&:hover td': {
            background: tableRow.hover,
          },
        },
      })}      
      muiTableBodyCellProps={{ sx: { border: 'none', color: text.main, align: 'center', boxShadow: 'none', } }}
      muiTableProps={{ sx: {backgroundColor: primary.main, color: text.main, boxShadow: 'none'} }}      
      muiTopToolbarProps={{ sx: {backgroundColor: primary.main, boxShadow: 'none', minHeight: 0} }}
      muiBottomToolbarProps={{ sx: {backgroundColor: primary.main, boxShadow: 'none'} }}
      muiTableHeadRowProps={{ sx: {backgroundColor: primary.main, color: text.main, textAlign: 'center'},}}
      muiTableHeadCellProps={{ sx:{borderBottom: 0, verticalAlign: 'none', boxShadow: 'none', align: 'center', color: text.main} }}
      enableColumnActions={false}
      initialState={{density: 'compact', showColumnFilters: true,}}
      enablePagination={true}
      positionPagination="bottom"
      muiTablePaginationProps={{
        rowsPerPageOptions: [5,10,15,20],
        sx: { color: text.main, '& p': { marginBottom: 0 }, '& .MuiSvgIcon-root': { color: text.main, },}
        }}
      enableRowSelection={(isSupport) ? false : true}
      enableSelectAll={false}
      positionToolbarAlertBanner={'none'}
      filterFns={{
        ProbeFilterFn: (row, _columnIds, filterValue) => {
            if (filterValue !== null) {
                if (filterValue !== 'All') {
                    return String(row.getValue('probe_serial_number')) === filterValue;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },
      }}
      renderBottomToolbar={({ table }) => {
          const handleDelete = () => {
              handleDeleteProbe();
              table.getSelectedRowModel().flatRows.map((row) => {
                setSelectedProbes(current => [...current, row.original]);
              });
          };

          return (
              <>
                {(isAccounting || isSalesAdmin || isSalesOperator) ?
                    (<div style={{ backgroundColor: primary.main}}>
                        <Button
                            color="secondary"
                            disabled={table.getSelectedRowModel().flatRows.length === 0}
                            onClick={handleDelete}
                            variant="contained"
                            size="small"
                            sx={{ mr: 1, ml: 1, mt: 1 }}
                        >
                            Delete Probe
                        </Button>
                        <Button onClick={resetMyFilters} mr={2} variant="contained"
                            sx={{
                                '&:hover': {
                                    backgroundColor: secondary.main,
                                },
                                mt: 1
                            }} color="secondary" size="small" startIcon={<RefreshIcon sx={{ backgroundColor: secondary.main }} size="small" />}>
                            Reset Filters
                        </Button>
                    </div>) : (<></>)
                }

                <Dialog open={confirmDeleteOpen} onClose={handleConfirmClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth='md'
                    sx={{ '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                        }
                    }}
                    >
                    <DialogTitle id="alert-dialog-title">
                        <Typography fontSize={size.lg} color={secondary.main} sx={{ fontWeight: 600,}}>{deleteMessageConfirmTitle}</Typography>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">{deleteMessageConfirm}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary" startIcon={<CancelIcon />}
                        onClick={handleDeleteNo}>No</Button>

                        <Button variant="contained" color="secondary" startIcon={<DeleteIcon />}
                        onClick={handleDeleteYes} autoFocus>Yes</Button>
                    </DialogActions>
                </Dialog>
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={showDeleteAlert}
                    autoHideDuration={6000}
                    key={vertical + horizontal}
                    onClose={handleDeleteAlertClose}
                >
                    <Alert elevation={6} variant="filled" onClose={handleDeleteAlertClose}
                        severity={pageAlertType || "error"} sx={{ "& .MuiAlert-message" :{ color: white.main, fontSize: size.sm}, marginBottom: 4 }}
                        >
                    {deleteAlertMsg}
                    </Alert>
                </Snackbar>
              </>
          );
      }}
    />
    );
}

export default ProbeStatus_table;